import { inject, provideAppInitializer } from '@angular/core'
import { Location } from '@angular/common'

import { getLocalStorage, removeLocalStorage, STORAGE_KEYS } from '@utils/storage'
import { Configuration } from '@definitions/guest-page-config'
import { TicketActionsState } from '@states/ticket-actions'
import { AppRoutes } from '@enums/app-routes'

export const locationConfigurationInitializer = provideAppInitializer(() => {
	const location = inject(Location)
	const ticketActionsState = inject(TicketActionsState)
	const configuration = getLocalStorage<Configuration>(STORAGE_KEYS.CONFIGURATION)
	const currentUrl = location.path()

	if (currentUrl !== AppRoutes.Payment) {
		removeLocalStorage(STORAGE_KEYS.CONFIGURATION)

		return
	}

	ticketActionsState.configuration.set(configuration)
})
